import React, { Component } from "react";
import "./projects.css";
import Loader from "../../components/loader/loader";
import firebase from "firebase";

export default class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      loading: true,
    };
  }

  componentDidMount() {
    firebase
      .firestore()
      .collection("projects")
      .get()
      .then((snap) => {
        var projects = [];
        snap.forEach((doc) => projects.push(doc.data()));
        this.setState({
          projects: projects,
          loading: false,
        });
      });
  }

  render() {
    return (
      <>
        {this.state.loading ? (
          <Loader />
        ) : (
          <div className="projects">
            <h1>PROJECTS</h1>
            <div className="portfolio-main">
              <h2>HAVE A LOOK AT OUR PROJECTS</h2>
              <div className="portfolio-content">
                {this.state.projects.map((project) => (
                  <a href={project.url} target="_blank" className="card">
                    <img src={project.image} alt="" />
                    <div className="cardDetail">
                      <h3>{project.title}</h3>
                      <h4>{project.description}</h4>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
